import type { ComponentType } from '@angular/cdk/portal';
import { InjectionToken } from '@angular/core';

export interface LazyModal {
  loadComponent(): Promise<ComponentType<any>>;
  loadModule(): Promise<any>;
}

export const MODALS = new InjectionToken<{ [k: string]: LazyModal }>('Modals');
